import Intro from './Intro';
import About from './About';
import Porfolio from './Porfolio';
import Contact from './Contact';
import Skills from './Skills';

function App() {
	return (
		<div className='App'>
			<Intro />

			<About />

			<Skills />

			<Porfolio />

			<Contact />
		</div>
	);
}

export default App;
